import React from "react";

export default function SendConfirmationInstructions() {
  return null;
}
